import * as BobPlayer from "./BobPlayer/index.js";
import * as Campaign from "./Campaign/index.js";
import * as ConfidentialityAgreement from "./ConfidentialityAgreement/index.js";
import * as DataRoomTask from "./DataRoomTask/index.js";
import * as Transunion from "./Transunion/index.js";
import * as WatchList from "./WatchList/index.js";
import * as Enums from "./Enums/index.js";
/** CoStar.Api.ListingUser.ViewModels.MarketingBrand */
export var MarketingBrand;
(function (MarketingBrand) {
    MarketingBrand[MarketingBrand["Unknown"] = 0] = "Unknown";
    MarketingBrand[MarketingBrand["LoopNet"] = 6] = "LoopNet";
    MarketingBrand[MarketingBrand["CityFeet"] = 7] = "CityFeet";
    MarketingBrand[MarketingBrand["Showcase"] = 8] = "Showcase";
    MarketingBrand[MarketingBrand["Realla"] = 13] = "Realla";
    MarketingBrand[MarketingBrand["TenX"] = 16] = "TenX";
    MarketingBrand[MarketingBrand["CoStarSuite"] = 9999] = "CoStarSuite";
})(MarketingBrand || (MarketingBrand = {}));
/** CoStar.Api.ListingUser.ViewModels.InterceptType */
export var InterceptType;
(function (InterceptType) {
    InterceptType[InterceptType["None"] = 0] = "None";
    InterceptType[InterceptType["Image"] = 1] = "Image";
    InterceptType[InterceptType["Url"] = 2] = "Url";
    InterceptType[InterceptType["Vbl"] = 3] = "Vbl";
    InterceptType[InterceptType["Vidly"] = 4] = "Vidly";
    InterceptType[InterceptType["Survey"] = 5] = "Survey";
    InterceptType[InterceptType["YouTube"] = 6] = "YouTube";
})(InterceptType || (InterceptType = {}));
/** CoStar.Api.ListingUser.ViewModels.ListingMergedReason */
export var ListingMergedReason;
(function (ListingMergedReason) {
    ListingMergedReason[ListingMergedReason["None"] = 0] = "None";
    ListingMergedReason[ListingMergedReason["ShoppingCenterRollup"] = 10] = "ShoppingCenterRollup";
    ListingMergedReason[ListingMergedReason["LocationIdUpdated"] = 20] = "LocationIdUpdated";
})(ListingMergedReason || (ListingMergedReason = {}));
/** CoStar.Api.ListingUser.ViewModels.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["ForSale"] = 1] = "ForSale";
    ListingType[ListingType["ForLease"] = 2] = "ForLease";
})(ListingType || (ListingType = {}));
import { AlertFrequencyType } from "../../../../CoStar/Api/ListingAlert/ViewModels/Enums/index.js";
/** CoStar.Api.ListingUser.ViewModels.AlertFrequencyType */
export { AlertFrequencyType };
/** CoStar.Api.ListingUser.ViewModels.ProspectType */
export var ProspectType;
(function (ProspectType) {
    ProspectType[ProspectType["None"] = 0] = "None";
    ProspectType[ProspectType["Email"] = 1] = "Email";
})(ProspectType || (ProspectType = {}));
/** CoStar.Api.ListingUser.ViewModels.UserActivityType */
export var UserActivityType;
(function (UserActivityType) {
    UserActivityType[UserActivityType["None"] = 0] = "None";
    UserActivityType[UserActivityType["LoopNetWebsiteSignIn"] = 1] = "LoopNetWebsiteSignIn";
})(UserActivityType || (UserActivityType = {}));
/** CoStar.Api.ListingUser.ViewModels.UserMergeAccountError */
export var UserMergeAccountError;
(function (UserMergeAccountError) {
    UserMergeAccountError[UserMergeAccountError["None"] = 0] = "None";
    UserMergeAccountError[UserMergeAccountError["TargetUserNotFound"] = 1] = "TargetUserNotFound";
})(UserMergeAccountError || (UserMergeAccountError = {}));
/** CoStar.Api.ListingUser.ViewModels.UserStatus */
export var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["None"] = 0] = "None";
    UserStatus[UserStatus["Active"] = 10] = "Active";
    UserStatus[UserStatus["Inactive"] = 20] = "Inactive";
    UserStatus[UserStatus["Deleted"] = 30] = "Deleted";
    UserStatus[UserStatus["Blocked"] = 40] = "Blocked";
})(UserStatus || (UserStatus = {}));
/** CoStar.Api.ListingUser.ViewModels.WatchFolderType */
export var WatchFolderType;
(function (WatchFolderType) {
    WatchFolderType[WatchFolderType["Unknown"] = 0] = "Unknown";
    WatchFolderType[WatchFolderType["ForLease"] = 1] = "ForLease";
    WatchFolderType[WatchFolderType["ForSale"] = 2] = "ForSale";
})(WatchFolderType || (WatchFolderType = {}));
export { BobPlayer, Campaign, ConfidentialityAgreement, DataRoomTask, Transunion, WatchList, Enums };
